module.exports = __webpack_public_path__ + "img/sample-error-2.f5cbd38.webp";